import { startCase } from 'lodash';

import { AdvanceConfig as GqlAdvanceConfig } from '@willow/graphql-iso/src/app/backend';
import { AdvanceCategory, AdvanceConfig } from '@willow/types-iso';

function getLabelFromCategory(category: AdvanceCategory): string {
  switch (category) {
    case 'BANKRUPTCY':
      return 'Bankruptcy';
    case 'FORCE_PLACED_INSURANCE':
      return 'Force Placed Insurance';
    case 'ATTORNEY_FEE':
      return 'Attorney Fee';
    case 'AGENT_FEE':
      return 'Agent Fee';
    case 'PROPERTY_PRESERVATION':
      return 'Property Preservation';
    case 'PROPERTY_INSPECTION_COST':
      return 'Property Inspection Cost';
    case 'BROKER_PRICE_OPINION_COST':
      return 'Broker Price Opinion (BPO) Cost';
    case 'APPRAISAL_COST':
      return 'Appraisal Cost';
    case 'TAXES':
      return 'Taxes';
    case 'TITLE_SEARCH':
      return 'Title Search';
    case 'PROTECTIVE_ADVANCE':
      return 'Protective Advance';
    default:
      return startCase(category.toLowerCase());
  }
}

export const getAdvanceCategoryLabel = (
  advanceConfig: AdvanceConfig | GqlAdvanceConfig | null | undefined,
): string | undefined => {
  if (!advanceConfig) return undefined;
  if (advanceConfig.advanceType === 'ESCROW') return 'Escrow';
  const { advanceCategory } = advanceConfig as { advanceCategory?: AdvanceCategory | null };
  if (advanceCategory) return getLabelFromCategory(advanceCategory);
  return undefined;
};
